import React, { useState, useEffect, useRef } from 'react';
import './OfflineIndicator.css';

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [syncMessage, setSyncMessage] = useState('');
  const [visible, setVisible] = useState(false);
  const wasOffline = useRef(false);
  const dismissTimer = useRef(null);

  useEffect(() => {
    const goOffline = () => {
      setIsOnline(false);
      setVisible(true);
      wasOffline.current = true;
      if (dismissTimer.current) clearTimeout(dismissTimer.current);
    };

    const goOnline = () => {
      setIsOnline(true);
      if (wasOffline.current) {
        setSyncMessage('Back online — syncing...');
        setVisible(true);
        dismissTimer.current = setTimeout(() => {
          setVisible(false);
          setSyncMessage('');
          wasOffline.current = false;
        }, 3000);
      }
    };

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'SYNC_COMPLETE') {
          const { success, failed } = event.data.payload;
          if (success > 0 || failed > 0) {
            setSyncMessage(
              failed > 0
                ? `Synced ${success} action(s), ${failed} failed`
                : `${success} queued action(s) synced successfully`
            );
            setVisible(true);
            dismissTimer.current = setTimeout(() => {
              setVisible(false);
              setSyncMessage('');
            }, 4000);
          }
        }
      });
    }

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
      if (dismissTimer.current) clearTimeout(dismissTimer.current);
    };
  }, []);

  if (!visible) return null;

  const barClass = isOnline ? 'pwa-offline-bar pwa-offline-bar--online' : 'pwa-offline-bar pwa-offline-bar--offline';

  return (
    <div className={barClass} dir="auto">
      <span className="pwa-offline-dot" />
      <span className="pwa-offline-text">
        {!isOnline
          ? "You're offline — changes will sync when connected"
          : syncMessage || 'Back online'
        }
      </span>
    </div>
  );
};

export default OfflineIndicator;
